import { DragEndEvent } from '@dnd-kit/core'
import { arrayMove } from '@dnd-kit/sortable'
import { AgxSortableList } from '@urbanx/agx-ui-components'
import { AgentDetails, UploadedDocument } from '@urbanx/agx.agencies.client'
import { AgxButton, AgxRow, AgxTypography } from '@urbanx/agx.ui-components2'
import { PlaceHolderImage } from 'components'
import { useCallback } from 'react'

const toggleOpacity = (
  event: React.MouseEvent<HTMLDivElement, MouseEvent>,
  opacity: number
) => {
  event.currentTarget.style.setProperty('opacity', `${opacity}`)
}

const SortableTeamMembers = ({
  orderedMembersList,
  agencyMembers,
  useAgentImage,
  orderUpdated,
}: {
  orderedMembersList: string[]
  agencyMembers: AgentDetails[]
  useAgentImage: (name: string, photo?: UploadedDocument) => void
  orderUpdated: (newOrder: string[]) => void
}) => {
  const renderItem = useCallback(
    (memberId: string, index: number) => {
      const member = agencyMembers?.find((agent) => agent.id === memberId)

      if (!member) return null

      return (
        <AgxRow
          justifyContent="space-between"
          alignItems="alignCenter"
          gap="spacing-xl"
          padding={{ top: 'spacing-xl', bottom: 'spacing-xl'}}
          fill
          key={`${index}`}
        >
          <div className="thPackageNameContainer__marketing">
            {member.photo ? (
              <img
                src={member.photo.publicPath}
                style={{
                  height: 45,
                  width: 45,
                  borderRadius: '50%',
                  marginRight: 16,
                }}
              />
            ) : (
              <PlaceHolderImage size={45} title={member.firstName} />
            )}
            <AgxTypography id={'memberName'} type={'body'} size={'small'}>
              {member.firstName} {member.lastName}
            </AgxTypography>
          </div>
          <div
            id={`${member.id}`}
            style={{
              display: 'flex',
              opacity: 0.5,
              width: '150px',
              justifyContent: 'flex-end',
            }}
            onMouseOver={(event) => toggleOpacity(event, 1)}
            onMouseOut={(event) => toggleOpacity(event, 0.5)}
          >
            <AgxButton
              id="btn-useImage"
              text="Use"
              size="medium"
              variant="naked"
              onClick={() =>
                useAgentImage(
                  `${member.firstName} ${member.lastName}`,
                  member.photo
                )
              }
            />
          </div>
        </AgxRow>
      )
    },
    [agencyMembers]
  )

  const handleOnDragEnd = useCallback(
    (event: DragEndEvent) => {
      const { active, over } = event

      if (active?.id === over?.id) return

      if (!orderedMembersList || orderedMembersList?.length === 0) return

      const oldIndex = orderedMembersList?.indexOf(active.id.toString())
      const newIndex =
        orderedMembersList?.indexOf(over?.id.toString() ?? '') || 0

      if (oldIndex === newIndex) return

      const updatedOrderItems = arrayMove(
        orderedMembersList!,
        oldIndex!,
        newIndex
      )

      orderUpdated(updatedOrderItems)
    },
    [orderedMembersList, orderUpdated]
  )

  return (
    <AgxSortableList
      items={orderedMembersList ?? []}
      getId={(memberId) => (memberId ? memberId : 'addTeam')}
      renderItem={(memberId, index) => renderItem(memberId, index)}
      onDragEnd={handleOnDragEnd}
      
    />
  )
}

export default SortableTeamMembers
